module.exports = __webpack_public_path__ + "static/3-min-002f8f314b4ea4bf70d3d734d498d694.jpg";